import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectMapLoading } from '../../slice/selectors';
import * as S from './MapLoadingToast.styles';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

interface IProps {}

const MapLoadingToast: FC<IProps> = props => {
  const { t } = useTranslation();

  const mapLoading = useSelector(selectMapLoading);

  return (
    <S.LoadingToast active={mapLoading}>
      <Spin size="default" />
      <span>{t('Map.FetchingData', 'Fetching data...')}</span>
    </S.LoadingToast>
  );
};

export default MapLoadingToast;
